"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retryable = void 0;
const _ = require("lodash");
const util_helper_1 = require("./util-helper");
function Retryable(maxAttempts, backOff, throwException = true) {
    return (target, methodName, descriptor) => {
        if (process.env.DISABLE_RETRYABLE_DECORATOR === "true") {
            return descriptor;
        }
        const { name: className } = target.constructor;
        const name = `${className}/${methodName}`;
        const method = descriptor.value;
        descriptor.value = function (...parameters) {
            try {
                const appliedMethodResult = method.apply(this, parameters);
                const isPromise = appliedMethodResult instanceof Promise;
                if (!isPromise) {
                    return appliedMethodResult;
                }
                return appliedMethodResult.catch(async (e) => {
                    // logger.warn(`${name} retrying error: ${e.message}`);
                    let retries = 1;
                    const maxRetries = typeof maxAttempts === "function" ? await maxAttempts(this) : maxAttempts;
                    while (retries <= maxRetries) {
                        try {
                            const sleep = typeof backOff === "function" ? await backOff(this, e, retries) : backOff;
                            if (_.isNaN(sleep) || sleep < 0) {
                                break;
                            }
                            await util_helper_1.UtilHelper.promiseSleep(sleep);
                            return await method.apply(this, parameters);
                        }
                        catch (e) {
                            // logger.warn(`${name} error on attempt ${retries}: ${e.message}`);
                        }
                        finally {
                            retries++;
                        }
                    }
                    // If we're here, method failed all retries
                    // logger.error(`Error executing method ${name} after ${retries - 1} attempts`);
                    if (!throwException) {
                        return;
                    }
                    throw e;
                });
            }
            catch (e) {
                // logger.warn(`Cannot retry sync method ${name}`);
                throw e;
            }
        };
        return descriptor;
    };
}
exports.Retryable = Retryable;
//# sourceMappingURL=retryable.decorator.js.map